/* global axios */
import BotifyAPI from './BotifyAPI';
class ProductCorpus extends BotifyAPI {
  constructor() {
    super('product-corpus', { accountScoped: true });
  }

  // ---------- NEW ENDPOINTS ----------

  /** GET /products/all - همه محصولات (بدون تفکیک) */
  listAll(params = {}) {
    return (
      this.ensureConfigured() ||
      axios.get(`${this.url}/products/all`, { params })
    );
  }

  /** GET /products/form - محصولات دستی (FORM) */
  listForm(params = {}) {
    return (
      this.ensureConfigured() ||
      axios.get(`${this.url}/products/form`, { params })
    );
  }

  /** GET /products/file - فایل‌ها با محصولاتشان (مثل /files) */
  listFile() {
    return this.ensureConfigured() || axios.get(`${this.url}/products/file`);
  }

  /** GET /products/woocommerce - WooCommerce ها با محصولاتشان */
  listWoocommerces(params = {}) {
    return (
      this.ensureConfigured() ||
      axios.get(`${this.url}/products/woocommerce`, { params })
    );
  }

  // ---------- LEGACY ENDPOINTS ----------

  /** برای سازگاری با کد قدیمی */
  list(params = {}) {
    return this.listAll(params);
  }

  /** POST /products - اضافه کردن محصولات دستی */
  addProducts(products) {
    return (
      this.ensureConfigured() ||
      axios.post(`${this.url}/products`, { products })
    );
  }

  /** PATCH /products - ویرایش محصولات */
  updateProducts(products) {
    return (
      this.ensureConfigured() ||
      axios.patch(`${this.url}/products`, { products })
    );
  }

  /** DELETE /products - حذف محصولات */
  deleteProducts(productIds) {
    return (
      this.ensureConfigured() ||
      axios.delete(`${this.url}/products`, { data: { productIds } })
    );
  }

  // ---------- FILES ----------

  /** POST /files - آپلود فایل‌ها */
  uploadFiles(files, options = {}) {
    const guard = this.ensureConfigured();
    if (guard) return guard;

    const fd = new FormData();
    (Array.isArray(files) ? files : [files]).forEach(f =>
      fd.append('file[]', f)
    );
    return axios.post(`${this.url}/files`, fd, {
      ...options,
    });
  }

  /** GET /files - لیست فایل‌ها */
  getFiles() {
    return this.ensureConfigured() || axios.get(`${this.url}/files`);
  }

  /** DELETE /files/{fileId} - حذف فایل */
  deleteFile(fileId) {
    return (
      this.ensureConfigured() || axios.delete(`${this.url}/files/${fileId}`)
    );
  }
}

export default new ProductCorpus();
